import Switch, { Props } from './Switch';
import FullWidthSwitch from './FullWidthSwitch';

import { LabelPosition } from './constants';

export { Switch, FullWidthSwitch, LabelPosition };
export type { Props };
export default Switch;
